import {
  Dispatch,
  useState
} from 'react';
import {
  SupportSlotsController
} from '../../../../api/support/support-slots.controller';
import {useAsyncEffect} from '../../../../hook/use-initial-load';
import {SupportSlotCustomerAssignmentModel} from '../../../../model/support/slot/support-slot-customer-assignment.model';
import {SupportSlotDefinitionModel} from '../../../../model/support/slot/support-slot-definition.model';

export namespace SupportSlotDefinitionPageHooks {
  export const useSupportSlotDefinitions = (): [SupportSlotDefinitionModel[], Dispatch<SupportSlotDefinitionModel[]>] => {
    const [slotDefinitions, setSlotDefinitions] = useState<SupportSlotDefinitionModel[]>([]);
    useAsyncEffect(async () => {
      setSlotDefinitions(await fetchSupportSlotDefinitions())
    }, []);
    return [slotDefinitions, setSlotDefinitions];
  }

  export const fetchSupportSlotDefinitions = async () =>
    (await SupportSlotsController.fetchSupportSlotDefinitions()).data


  export const useSupportSlotDefinitionAssignments = (slotDefinitionId: string): [SupportSlotCustomerAssignmentModel[], Dispatch<SupportSlotCustomerAssignmentModel[]>] => {
    const [slotDefinitionAssignments, setSlotDefinitionAssignments] = useState<SupportSlotCustomerAssignmentModel[]>([]);
    useAsyncEffect(async () => {
      setSlotDefinitionAssignments(await fetchSupportSlotDefinitionAssignments(slotDefinitionId))
    }, []);
    return [slotDefinitionAssignments, setSlotDefinitionAssignments];
  }

  export const fetchSupportSlotDefinitionAssignments = async (slotDefinitionId: string) =>
    (await SupportSlotsController.fetchSupportSlotDefinitionAssignments(slotDefinitionId))
}